import config from '@/config'
import axios from 'axios'
import iView from 'view-design'
import { setToken, getToken } from '@/libs/util'
import router from '@/router'

export const baseUrl = (process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro) + 'admin/'

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  interceptors (instance) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      const { data, status } = res
      
      // 调试日志
      if (res.config && res.config.url && res.config.url.includes('Login/index')) {
        console.log('登录API响应拦截器 - 原始响应:', res)
        console.log('登录API响应拦截器 - data:', data)
      }
      
      // 检查后端返回的success字段
      if (data.success === false) {
        const errorMsg = data.msg || '请求失败'
        iView.Message.error(errorMsg)
        throw new Error(errorMsg)
      }
      
      if (data.code < 0) {
        if (data.code === -14) {
          setToken('')
          router.push({ name: 'login' })
        } else {
          iView.Message.error(data.msg || '请求失败')
        }
        throw new Error(data.msg || '请求失败')
      } else {
        return { data, status }
      }
    }, error => {
      // 处理网络错误或其他错误
      let errorMsg = '网络错误，请稍后重试'
      if (error.response) {
        // 服务器返回了错误响应
        const { data } = error.response
        errorMsg = (data && data.msg) || (data && data.message) || `请求失败 (${error.response.status})`
      } else if (error.request) {
        // 请求已发出但没有收到响应
        errorMsg = '无法连接到服务器，请检查网络连接'
      } else {
        // 其他错误
        errorMsg = error.message || '请求失败'
      }
      console.error('API请求错误:', error)
      iView.Message.error(errorMsg)
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    let apiAuth = getToken()
    if (apiAuth === false) {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {}
      }, options)
    } else {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          'Api-Auth': apiAuth,
          'Authorization': 'bearer '+apiAuth
        }
      }, options)
    }
    this.interceptors(instance)
    return instance(options)
  }
}

const api_axios = new HttpRequest(baseUrl)
export default api_axios
